module.exports = __webpack_public_path__ + "img/chemmaster-logo-retina.73c003d8.svg";